import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BoxingGlove } from "@phosphor-icons/react";

import { useMyDuels } from "../../duelsApi";

/**
 * W-IA-2h (IA_CANON_v2 раздел 2.7) — виджет активной дуэли на Сегодня.
 *
 * Пока идёт дуэль — это ежедневная мотивация, ей место в кабине дня.
 * Показываем ПЕРВУЮ активную дуэль (у 1v1-формата их обычно 0-1);
 * ничего активного → null. Имена участников здесь легитимны — viewer
 * участник (кольцо 2, duels_and_challenges.md раздел 7); свою строку зовём «Я».
 */
export function TodayDuelWidget() {
  const nav = useNavigate();
  const { t } = useTranslation("dashboard");
  const { data } = useMyDuels();
  const duel = (data ?? []).find((d) => d.status === "active");
  if (!duel) return null;

  const fmt = (v: number | null) =>
    v === null ? "—" : `${v >= 0 ? "+" : ""}${v.toFixed(1)}%`;

  return (
    <button
      type="button"
      data-testid="today-duel-widget"
      onClick={() => nav("/challenges")}
      className="indigo-card p-3 w-full text-left flex items-center justify-between gap-3 hover:bg-bg-raised active:bg-bg-raised transition-colors"
    >
      <div className="min-w-0">
        <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-fg-muted">
          {t("duel.eyebrow", { defaultValue: "ДУЭЛЬ" })} · {duel.title} ·{" "}
          {t("duel.days_left", { defaultValue: "{{n}}д", n: duel.days_left })}
        </div>
        <div className="text-sm text-fg-primary mt-0.5 num-display truncate">
          {duel.participants.map((p, i) => (
            <span key={p.athlete_id}>
              {i > 0 && " · "}
              {p.name || t("duel.opponent", { defaultValue: "Атлет" })}{" "}
              <span className="font-semibold">{fmt(p.improvement_pct)}</span>
            </span>
          ))}
        </div>
      </div>
      <BoxingGlove size={18} className="text-fg-secondary shrink-0" aria-hidden />
    </button>
  );
}
